/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */
import { faker } from '@faker-js/faker';
import { HttpResponse, delay, http } from 'msw';

export const getGetApPayeeContactInformPdfTemplateDefaultMock = () => ({
  context: faker.helpers.arrayElement([faker.word.sample(), undefined]),
  destination: faker.word.sample(),
  sender: faker.word.sample(),
  title: faker.word.sample(),
});

faker.seed(1);

export const handlers = [
  http.get(
    '*/api/js/ap_payee_contact_inform_pdf_template/default',
    async () => {
      await delay(1000);
      return new HttpResponse(
        JSON.stringify(getGetApPayeeContactInformPdfTemplateDefaultMock()),
        {
          status: 200,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
  ),
];
